import {PIXI} from '@colonist/pixi'
import {CardPopupInformation} from '@colonist/game-card-types'
import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {UIGamePopupCardConfirmation} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupCardConfirmation'
import {UIGamePopupConfirmationButtons} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupConfirmationButtons'
import {UIGamePopupInformationView} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupInformationView'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {CardEnum} from '@colonist/game-states'

export class UIMGamePopupCardConfirmation extends UIGamePopupCardConfirmation {
    private showCancelButton: boolean
    private readonly cancelActionWithoutPropagation: (e: PIXI.FederatedEvent) => void

    constructor(uiGameManager: UIGameManager, popupInformationFormat: CardPopupInformation) {
        super(uiGameManager, popupInformationFormat)
        this.y = this.canvas.appH - this.canvas.bottomViewHeight - this.absoluteHeight
        this.cancelActionWithoutPropagation = (e: PIXI.FederatedEvent) => {
            this.onCancelButton()
            e.stopPropagation()
            this.uiGameManager.eventController.sendEvent(undefined, GameStateEnums.UIGameEventEnums.ClosePopupUI)
        }
        if(this.showCancelButton) return
        this.uiGameManager.mapController.mapView.on('pointerdown', this.cancelActionWithoutPropagation)
    }

    setCancelAction(action: () => void) {
        this.uiGameManager.mapController.mapView.off('pointerdown', this.cancelActionWithoutPropagation)
        this.onCancelButton = action
        if(this.showCancelButton) {
            this.confirmationButtons.cancelButton.updateAction(action)
            return
        }
        this.uiGameManager.mapController.mapView.on('pointerdown', action)
    }

    protected createPopupView() {
        const cardsThatNeedCancelButton = [CardEnum.ProgressCardScienceInventor, CardEnum.ProgressCardPoliticsDiplomat, CardEnum.ProgressCardScienceSmith, CardEnum.ProgressCardTradeCommercialHarbor]
        this.showCancelButton = cardsThatNeedCancelButton.includes(this.cardEnum)

        const w = this.canvas.popupWidth
        const bottomButtonH = this.canvas.itemSize

        const cardInformationW = w - bottomButtonH * (this.showCancelButton ? 2 : 1)
        this.cardPopupInformation = new UIGamePopupInformationView(this.uiGameManager, 0, 0, cardInformationW, this.popupInformation, this)

        const minPopupViewHeight = 2.25 * this.canvas.itemSize
        const popupViewHeight = this.cardPopupInformation.height
        const additionalHeight = popupViewHeight < minPopupViewHeight ? minPopupViewHeight - popupViewHeight : 0
        const padding = this.uiGameManager.canvasController.itemSize / 6 + additionalHeight
        this.drawTextureBgAroundContent(0, padding)

        const bottomButtonY = this.absoluteHeight - bottomButtonH
        this.confirmationButtons = new UIGamePopupConfirmationButtons(0, bottomButtonY, w, bottomButtonH, this.onCheckButton, this.onCancelButton, this, this.showCancelButton)
        this.confirmationButtons.checkButton.activateOpacity()
    }

    destroy() {
        this.uiGameManager.mapController.mapView.off('pointerdown', this.cancelActionWithoutPropagation)
        super.destroy()
    }
}
